module.exports = __webpack_public_path__ + "img/kg_kg_09.b9802a75.png";